import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { whatsappLink } from "@/constants/site";
import { hostingFaqs } from "@/mocks/hospedagem";

export default function HostingFaq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-700">
                <i className="ri-question-line" aria-hidden="true"></i>
                Dúvidas sobre hospedagem
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Perguntas frequentes.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Reunimos as dúvidas mais comuns sobre hospedagem e migração. Não encontrou o que
                procurava?
              </p>
              <a
                href={whatsappLink("Ola! Tenho dúvidas sobre os planos de hospedagem da NXHOST.")}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
                Falar com um especialista
              </a>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="flex flex-col gap-3">
              {hostingFaqs.map((faq, index) => {
                const isOpen = open === index;
                return (
                  <div
                    key={faq.question}
                    className={`rounded-xl border bg-background-50 transition-colors ${
                      isOpen ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i
                          className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}